import { useEffect, useState } from 'react';
import { Button } from '../../components/Button';
import { Card } from '../../components/Card';
import { HelmetComponent } from '../../components/Helmet';
import { List, ListItem } from '../../components/List';
import { useAuth } from '../../hooks/useAuth';

import { Markup } from 'interweave';
import { useNavigate } from 'react-router-dom';
import _ from 'underscore';
import * as routes from '../../constants/Routes';
import { api } from '../../server/api';
import moment from 'moment';
interface INotifications {
  notificationType: any;
  notificationTitle: string;
  notificationContent: string;
  createdAt: number;
  scope?: string;
  sended?: boolean;
  playersWhoRead: object;
}

export function Notifications() {
  const navigate = useNavigate();
  const {
    client,
    getNotifications,
    notifications,
    player,
    notificationCategory1,
    notificationCategory2,
  } = useAuth();

  const [allNotifications, setAllNotifications] = useState<
    Array<INotifications>
  >([]);

  useEffect(() => {
    getNotifications();
  }, []);

  useEffect(() => {
    const allNotificationsList =
      notificationCategory1 &&
      notificationCategory1.concat(notificationCategory2);
    // console.log(allNotificationsList);

    setAllNotifications(_.sortBy(allNotificationsList, 'createdAt').reverse());
  }, [notifications]);

  const updateReadNotifications = async (notification: any) => {
    // console.log('entrou aqui', notification.id);
    const parameters = {
      updateFunctionality: 'updateReadNotifications',
      userType: 'player',
      playerId: player.id,
      notificationId: notification.id,
      clientId: client.id,
    };

    await api
      .post(`/update`, parameters)
      .then(() => {
        getNotifications();
        // console.log('🚀 ~ file: index.tsx ~ line 42 ~ .then ~ res', res);
        //Notify(result.message, result.success ? "success" : "error");
      })
      .catch((error) => {
        console.log('ERRO AO FAZER O UPDATE:', error);
      });
  };
  const handleRedirectNotification = (notification: any) => {
    console.log('🚀 ~notification:', notification);
    if (notification.notificationType === 'newAction') {
      return navigate(`${routes.ACTION_DETAILS}/${notification.actionId}`);
    }
    if (notification.notificationType === 'newRescue') {
      return navigate(`${routes.MY_RESCUES}`);
    }
    if (
      ['newLead', 'newConversionLead', 'advancedStepLead'].includes(
        notification.notificationType
      )
    ) {
      return navigate(`${routes.MY_INDICATIONS}`);
    }
    if (notification.notificationType === 'membergetmember') {
      return navigate(`${routes.PROSPECTS}`);
    }
    if (notification.notificationType === 'newPoints') {
      return navigate(`${routes.PROFILE}`);
    }
  };

  const scopsActions = [
    'newAction',
    'newLead',
    'newRescue',
    'newConversionLead',
    'membergetmember',
    'newPoints',
  ];

  return (
    <>
      <HelmetComponent
        clientLogoURL={client.logoURL}
        companyName={client.companyName}
        clientFavicon={client.favIcon}
        tabTitle={'Notificações'}
      />
      <div className="container">
        <div className="d-flex align-items-center my-3">
          <i className="material-icons-outlined me-3 color-text">
            notifications_active
          </i>
          <span className="fs-4">Notificações</span>
        </div>
        <div className="my-3">
          {/* Nessa primeira categoria mostra os 10 primeiros */}
          <Card>
            <List>
              {allNotifications &&
                allNotifications.length > 0 &&
                allNotifications.map(
                  (notification: INotifications, index: number) => {
                    return (
                      <ListItem
                        icon="notifications"
                        key={index}
                        content={
                          <Markup
                            content={`<div><p class="fw-semibold m-0 ${
                              (notification.scope === 'direct' &&
                                !notification.sended) ||
                              (!notification.playersWhoRead && 'opacity-50')
                            }" >${
                              notification.notificationTitle
                            }</p >  <p class="${
                              (notification.scope === 'direct' &&
                                !notification.sended) ||
                              !notification.playersWhoRead
                                ? 'm-0 fw-semibold'
                                : 'm-0'
                            }">${
                              notification.notificationContent
                            }</p> <p class="m-0">${moment(
                              notification.createdAt
                            ).format('DD/MM/YYYY HH:mm')}</p></div>`}
                          />
                        }
                        onClick={() => {
                          if (
                            (notification.scope === 'direct' &&
                              !notification.sended) ||
                            !notification.playersWhoRead
                          ) {
                            updateReadNotifications(notification);
                          }
                        }}
                        secondaryContent={
                          <>
                            {notification &&
                              scopsActions.includes(
                                `${notification.notificationType}`
                              ) && (
                                <Button
                                  text=""
                                  icon="arrow_forward_ios"
                                  onClick={() =>
                                    handleRedirectNotification(notification)
                                  }
                                />
                              )}
                          </>
                        }
                      />
                    );
                  }
                )}
              {allNotifications && allNotifications.length === 0 && (
                <ListItem
                  icon="notifications_paused"
                  content="Nenhuma notificação"
                />
              )}
            </List>
          </Card>
        </div>
      </div>
    </>
  );
}
